const THEME_STORAGE_KEY = "logboek24_theme";

const THEME_CLASS_MAP = {
  default: "default",
  "high-contrast": "theme-contrast",
  dark: "theme-dark",
  "large-text": "theme-large",
};

const THEME_CLASSES = Object.values(THEME_CLASS_MAP);

export function normalizeTheme(theme) {
  return THEME_CLASS_MAP[theme] ? theme : "default";
}

export function applyTheme(theme) {
  const nextTheme = normalizeTheme(theme);
  const className = THEME_CLASS_MAP[nextTheme];

  if (typeof document !== "undefined") {
    document.body.classList.remove(...THEME_CLASSES);
    if (className !== "default") {
      document.body.classList.add(className);
    }
  }

  return nextTheme;
}

export function clearTheme() {
  if (typeof document !== "undefined") {
    document.body.classList.remove(...THEME_CLASSES);
  }
}

export function getStoredTheme() {
  try {
    const raw = localStorage.getItem(THEME_STORAGE_KEY);
    return normalizeTheme(raw || "default");
  } catch {
    return "default";
  }
}

export function applyStoredTheme() {
  return applyTheme(getStoredTheme());
}

export function saveTheme(theme) {
  const nextTheme = applyTheme(theme);
  try {
    localStorage.setItem(THEME_STORAGE_KEY, nextTheme);
  } catch {
    // Ignore storage errors and keep runtime theme.
  }
  return nextTheme;
}

export { THEME_STORAGE_KEY };
